// components/global-dialog.tsx
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useDialogStore } from "./alert-dialog-store";

export function GlobalAlertDialog() {
  const { isOpen, config, closeDialog } = useDialogStore();

  if (!config) return null;

  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && closeDialog()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{config.title}</AlertDialogTitle>
          <AlertDialogDescription>{config.description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => config.onCancel?.()}>
            {config.cancelText || "Annulla"}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              config.onConfirm();
              closeDialog();
            }}
          >
            {config.confirmText || "Continua"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
